// extracted by mini-css-extract-plugin
export default {"chartWrapper":"DonutChart_chartWrapper__0Ws0v","chart":"DonutChart_chart__XbnpU","centerLabel":"DonutChart_centerLabel__AConR"};